import { axios, toCamelCase, toSnakeCase } from '@utils';

const BASE_URL = '/api/v1/legup';

async function fetchAgeGroups(centerId) {
  try {
    const { data } = await axios.get(`${BASE_URL}/age_groups?center_id=${centerId}`);
    return toCamelCase(data);
  } catch (error) {
    throw new Error(error);
  }
}

async function updateClassrooms(ageGroupId, classrooms) {
  try {
    const { data } = await axios.put(`${BASE_URL}/age_groups/${ageGroupId}/update_classrooms`, {
      classrooms,
    });
    return toCamelCase(data);
  } catch (error) {
    throw new Error(error);
  }
}

async function createAgeGroup(centerId, ageGroup) {
  try {
    const { data } = await axios.post(`${BASE_URL}/age_groups`, toSnakeCase({ centerId, ageGroup }));
    return toCamelCase(data);
  } catch (error) {
    throw new Error(error);
  }
}

async function updateAgeGroup(id, ageGroup) {
  try {
    const { data } = await axios.put(`${BASE_URL}/age_groups/${id}`, toSnakeCase({ ageGroup }));
    return toCamelCase(data);
  } catch (error) {
    throw new Error(error);
  }
}

async function deleteAgeGroup(id) {
  try {
    await axios.delete(`${BASE_URL}/age_groups/${id}`);
    return true;
  } catch (error) {
    throw new Error(error);
  }
}

export {
  fetchAgeGroups,
  createAgeGroup,
  updateAgeGroup,
  deleteAgeGroup,
  updateClassrooms,
};
